import { render } from "./HeroiconsSolidQrcode.vue?vue&type=template&id=5b5c1548"
const script = {}

import exportComponent from "C:\\laragon\\www\\idmex-api\\vendor\\laravel\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidQrcode.vue"]])

export default __exports__